import { call, all, takeEvery, put, fork } from 'redux-saga/effects';
import { notification } from '@isomorphic/shared/isomorphic/components';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';

/*
User Sagas
*/

export function* userFields() {
  yield takeEvery(actions.USER_FIELDS, function*() {
    console.log('GET user/fields (no queryString)');
    const response = yield call(SuperFetch.get, 'user/fields');
    console.log('RESPONSE user/fields:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let fields = response.Data.Fields;
      let fieldgroups = response.Data.FieldGroups;
      yield put({
        type: actions.USER_FIELDS_SUCCESS,
        fields: fields,
        fieldgroups: fieldgroups,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true); //allow silent if server error
    }
  });
}

export function* users() {
  yield takeEvery(actions.USERS, function*({ queryString }) {
    console.log('GET users queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(SuperFetch.get, 'user?' + queryString);
    console.log('RESPONSE users:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let users = response.Data.Users;
      yield put({
        type: actions.USERS_SUCCESS,
        users: users,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userCreate() {
  yield takeEvery(actions.USER_CREATE, function*({ createdUser }) {
    console.log(createdUser);
    let users = [];
    users.push(createdUser);
    const data = { Data: { Users: users } };
    console.log('POST users/create json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'user/create', data);
    console.log('RESPONSE users/create:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let userCreateSuccess = response.Data.Users[0];
      yield put({
        type: actions.USER_CREATE_SUCCESS,
        userCreateSuccess: userCreateSuccess,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userUpdate() {
  yield takeEvery(actions.USER_UPDATE, function*({ updatedUser }) {
    let users = [];
    users.push(updatedUser);
    const data = { Data: { Users: users } };
    console.log('POST user/update json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'user/update', data);
    console.log('RESPONSE user/update:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let userUpdateSuccess = response.Data.Users[0];
      yield put({
        type: actions.USER_UPDATE_SUCCESS,
        userUpdateSuccess: userUpdateSuccess,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userLookup() {
  yield takeEvery(actions.USER_LOOKUP, function*({ queryString }) {
    console.log('GET user/lookup queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(SuperFetch.get, 'user/lookup?' + queryString);
    console.log('RESPONSE user/lookup:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let userLookupSuccess = response.Data.User;
      yield put({
        type: actions.USER_LOOKUP_SUCCESS,
        userLookupSuccess: userLookupSuccess,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userDelete() {
  yield takeEvery(actions.USER_DELETE, function*({ deletedUser }) {
    var queryString = 'ID=' + deletedUser.ID;
    console.log('POST user/Deactivate');
    console.log(JSON.stringify(queryString));
    let data = {ID: deletedUser.ID}
    const response = yield call(
      SuperFetch.post,
      'user/Deactivate?', data
    );
    if (response.Status !== 'error' && !response.error) {
      let userDeleteSuccess = deletedUser;
      yield put({
        type: actions.USER_DELETE_SUCCESS,
        userDeleteSuccess: userDeleteSuccess,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userResetChallengeAnswers() {
  yield takeEvery(actions.USER_RESET_CHALLENGE_ANSWERS, function*({ userId }) {
    var queryString = 'id=' + userId;
    console.log('DELETE user/DeleteUserChallengeAnswers queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(
      SuperFetch.delete,
      'user/DeleteUserChallengeAnswers?' + queryString
    );
    if (response.Status !== 'error' && !response.error) {
      let userResetChallengeAnswersSuccess = response.Message;
      yield notification('success', response.Message);
      yield put({
        type: actions.USER_RESET_CHALLENGE_ANSWERS_SUCCESS,
        userResetChallengeAnswersSuccess: userResetChallengeAnswersSuccess,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userMassUpdate() {
  yield takeEvery(actions.USER_MASSUPDATE, function*({ updatedUsers }) {
    let data = { Data: { User: updatedUsers } };
    console.log('POST user/massupdate json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'user/massupdate', data);
    if (response.Status !== 'error' && !response.error) {
      let userMassUpdateSuccess = updatedUsers;
      yield put({
        type: actions.USER_MASSUPDATE_SUCCESS,
        userMassUpdateSuccess: userMassUpdateSuccess,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userImport() {
  yield takeEvery(actions.USER_IMPORT, function*({ importedUsers }) {
    const data = { Data: { Users: importedUsers } };
    console.log('POST user/import json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'user/create', data);
    if (response.Status !== 'error' && !response.error) {
      let userImportSuccess = importedUsers;
      yield put({
        type: actions.USER_IMPORT_SUCCESS,
        userImportSuccess: userImportSuccess,
      });
    } else {
      yield put({
        type: actions.USER_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

/*
Saga loader
*/
export default function* rootSaga() {
  yield all([
    fork(userFields),
    fork(users),
    fork(userLookup),
    fork(userCreate),
    fork(userUpdate),
    fork(userMassUpdate),
    fork(userImport),
    fork(userResetChallengeAnswers),
    fork(userDelete),
  ]);
}
